import { render, staticRenderFns } from "./verified-caller-id-bundle-table.vue?vue&type=template&id=53cd7044"
import script from "./verified-caller-id-bundle-table.vue?vue&type=script&lang=js"
export * from "./verified-caller-id-bundle-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports